module.exports = {
      id: "ic-active-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-active-usage",
      toString: function () {
        return this.url;
      }
    }